import { render, staticRenderFns } from "./RelativesInfo.vue?vue&type=template&id=6b0a1856&scoped=true&"
import script from "./RelativesInfo.vue?vue&type=script&lang=js&"
export * from "./RelativesInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0a1856",
  null
  
)

export default component.exports